import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppConfig } from '../context/AppConfigContext.jsx';

const SourceLink = (props) => {
  const navigate = useNavigate();
  const { urls } = useAppConfig();
  const handleClick = (event) => {
    event.preventDefault();
    navigate('/');
  };
  return <a href={urls.source} onClick={handleClick} rel="noopener noreferrer" {...props} />;
};

export default SourceLink;
